import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product__left"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "product__title"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "product__description"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "product__accordion" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-color-um-blue" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "product__location"
}
const _hoisted_14 = { class: "text-color-um-blue" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "map" }, null, -1)
const _hoisted_16 = { class: "product__right" }
const _hoisted_17 = { class: "product__overview" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "product__title"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "product__description"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "product__list" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-color-um-blue" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-color-um-blue" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "product__list" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "text-color-um-blue" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "product__list" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "text-color-um-blue" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = {
  key: 7,
  class: "product__location"
}
const _hoisted_46 = { class: "text-color-um-blue" }
const _hoisted_47 = {
  key: 0,
  class: "product__actions"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product", !_ctx.compact ? 'product--lg' : ''])
  }, [
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("template", null, [
            _createElementVNode("div", {
              class: "product__image",
              style: _normalizeStyle([
            _ctx.state.imagePath
              ? 'background-image:url(' + _ctx.state.imagePath + ')'
              : '',
          ])
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'research-equipment-detail', params: { id: _ctx.data.id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.state.imageDefaultPath,
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }, 8, ["to"])
            ], 4)
          ]),
          (_ctx.data.name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.data.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_router_link, {
                        to: { name: 'research-equipment-detail', params: { id: _ctx.data.id } }
                      }, {
                        default: _withCtx(() => [
                          (_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.data.name.slice(0, 67)), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.data.nameEnglish?.slice(0, 67)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.data.accessPurposeDescription)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.data.accessPurposeDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.data.accessPurposeDescription.slice(0, 100)), 1),
                      _createVNode(_component_router_link, {
                        class: "router-link read-more text-color-gray-700",
                        to: { name: 'research-equipment-detail', params: { id: _ctx.data.id } }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.viewMoreText")) + "...", 1),
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.data.components[0])
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentComponentTitle")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.data.components)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_Accordion, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.components, (child, index_child) => {
                        return (_openBlock(), _createBlock(_component_AccordionTab, {
                          key: index_child,
                          header: child.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.description), 1)
                          ]),
                          _: 2
                        }, 1032, ["header"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.displayLeftContains('location') && _ctx.data.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.t("content.researchEquipment.content.locationTitle")), 1)
                ]),
                _hoisted_15
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        (_ctx.data)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product__image",
              style: _normalizeStyle([
              _ctx.state.imagePath
                ? 'background-image:url(' + _ctx.state.imagePath + ')'
                : '',
            ])
            }, [
              _createVNode(_component_router_link, {
                to: {
                name: 'research-equipment-detail',
                params: { id: _ctx.data.id },
              }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.state.imageDefaultPath,
                    alt: ""
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              }, 8, ["to"])
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.data.name && _ctx.compact)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.data.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: {
                name: 'research-equipment-detail',
                params: { id: _ctx.data.id },
              }
                    }, {
                      default: _withCtx(() => [
                        (_ctx.defaultLanguageSelected)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_20, _toDisplayString(_ctx.data.name.slice(0, 67)), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.defaultLanguageSelected)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_21, _toDisplayString(_ctx.data.nameEnglish?.slice(0, 67)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.accessPurposeDescription && _ctx.compact)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_ctx.data.accessPurposeDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.data.accessPurposeDescription.slice(0, 100)), 1),
                    _createVNode(_component_router_link, {
                      class: "router-link read-more text-color-gray-700",
                      to: {
                name: 'research-equipment-detail',
                params: { id: _ctx.data.id },
              }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.viewMoreText")) + "...", 1),
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_24,
        (_ctx.data.researchEntity)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_25, [
                (_ctx.data.researchEntity.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                      _createElementVNode("strong", _hoisted_27, _toDisplayString(_ctx.t("content.researchEquipment.content.researchEntityTitle")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data.researchEntity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: "Research Entity Location",
                          href: _ctx.data.researchEntity.id
                        }, null, 8, ["href"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "pi pi-link",
                          label: "https://www.um.si",
                          href: _ctx.data.researchEntity.id
                        }, null, 8, ["href"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_29
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.researchInfrastructure)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (_ctx.data.researchInfrastructure?.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.t("content.researchEquipment.content.researchEntityTitle")), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: `${
                      _ctx.defaultLanguageSelected
                        ? `${_ctx.data.researchInfrastructure?.name}`
                        : `${_ctx.data.researchInfrastructure?.nameEnglish}`
                    }`
                        }, null, 8, ["label"])
                      ]),
                      (_ctx.data.researchInfrastructure.contactUsers[0])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                            _createVNode(_component_IconTextBlock, {
                              icon: "icon-user",
                              label: `${_ctx.data.researchInfrastructure.contactUsers[0].firstname} ${_ctx.data.researchInfrastructure.contactUsers[0].lastname}`
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.researchInfrastructure.contactUsers[0])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                            _createVNode(_component_IconTextBlock, {
                              icon: "icon-phone",
                              label: 
                      _ctx.data.researchInfrastructure.contactUsers[0].phoneNumber
                    
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.data.researchInfrastructure.contactUsers[0])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                            _createVNode(_component_IconTextBlock, {
                              icon: "icon-envelope-3",
                              label: _ctx.data.researchInfrastructure.contactUsers[0].email
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.contactUsers[0])
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", _hoisted_35, [
                (_ctx.data.contactUsers[0].email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                      _createElementVNode("strong", _hoisted_37, _toDisplayString(_ctx.t("content.researchEquipment.content.responsiblePersonTitle")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data.contactUsers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-user",
                          label: `${_ctx.data.contactUsers[0].firstname} ${_ctx.data.contactUsers[0].lastname}`
                        }, null, 8, ["label"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-phone",
                          label: _ctx.data.contactUsers[0].phoneNumber
                        }, null, 8, ["label"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-envelope-3",
                          label: _ctx.data.contactUsers[0].email
                        }, null, 8, ["label"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_39
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.data.researchOrganization)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", _hoisted_40, [
                (_ctx.data.researchOrganization)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                      _createElementVNode("strong", _hoisted_42, _toDisplayString(_ctx.t(
                  "content.researchEquipment.content.memberOfTheUniversityOfMariborTitle"
                )), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data.researchOrganization)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: `${
                    _ctx.defaultLanguageSelected
                      ? `${_ctx.data.researchOrganization.name} <br/> ${_ctx.data.location.street} <br/> ${_ctx.data.location.postalCode}`
                      : `${_ctx.data.researchOrganization.nameEnglish} <br /> ${_ctx.data.location.street} <br /> ${_ctx.data.location.postalCode}`
                  }`
                        }, null, 8, ["label"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "icon-pin",
                          label: `${_ctx.data.location?.departments[0]?.name}`
                        }, null, 8, ["label"])
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_IconTextBlock, {
                          icon: "pi pi-link",
                          label: _ctx.data.researchOrganization.websiteURL,
                          href: _ctx.data.researchOrganization.id
                        }, null, 8, ["label", "href"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_44
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.displayContains('location') && _ctx.data.location)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", _hoisted_46, _toDisplayString(_ctx.t("content.researchEquipment.content.locationTitle")), 1)
              ]),
              _createVNode(_component_GoogleMapsSmall, {
                location: _ctx.state.locationData
              }, null, 8, ["location"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _hoisted_48,
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}